import request from "@/utils/request";
// 消息接收渠道页
export function GetRemindChannelSet(params) {
  return request({
    url: "/h5/setting/getRemindChannelSet",
    method: "post",
    params,
  });
}
export function SetRemindChannel(params) {
  return request({
    url: "/h5/setting/SetRemindChannel",
    method: "post",
    params,
  });
}
// '立即续费'弹窗判断
export function renew(params) {
  return request({
    url: "/h5/Coupon/renew",
    method: "post",
    params,
  })
}
// 设置免打扰时间
export function saveMuteSet(params) {
  return request({
    url: "/h5/setting/saveMuteSet",
    method: "post",
    params,
  })
}